const state = {
	benefit_types_index: {
		data: [],
		links: {},
		meta: {},
	},
};

export default state;
